import * as React from 'react';
import { ScoreType } from '../../../models';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { PVASelect } from './PVASelect';
import './PVASelect.css';

interface PVARawScoreSelectProps {
    options: ScoreType[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
}


@inject('FilterStore') @observer
export class PVARawScoreSelect extends React.Component<PVARawScoreSelectProps> {
    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    private selectedRawScore() {
        if (!this.props.selected) {
            return null;
        }
        
        return this.props.options.find((c: ScoreType) => {
            return c.id === this.props.selected;
        });
    }

    private rawScoreChange(rawScore: ScoreType) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: rawScore.id
                }
            });
        }
    }

    rawScoreSort(a: ScoreType, b: ScoreType) {
        if (a.sort > b.sort) {
            return 1;
        }
        if (a.sort < b.sort) {
            return -1;
        }
        return 0;
    }

    private sortScoreType(a: ScoreType, b: ScoreType) {
        if (a.sort > b.sort) {
            return 1;
        } else if (a.sort < b.sort) {
            return -1;
        }
        return 0;
    }
    
    renderOptions = () => {
        var trueFalseScoreTypes = this.props.options.filter(entity => {
            return entity.scoringType === 'trueFalse' || entity.scoringType === 'trueFalseInconsistent';
        });

        var likertScoreTypes = this.props.options.filter(entity => {
            return entity.scoringType === 'likert' || entity.scoringType === 'likertInconsistent';
        });

        var maxScoreTypes = this.props.options.filter(entity => {
            return entity.scoringType === 'maxScore';
        });

        var availableAreasTF: string[] = [];
        var areasAddedTF: any = {};
        var availableAreasLikert: string[] = [];
        var areasAddedLikert: any = {};
        var availableAreasMaxScore: string[] = [];
        var areasAddedMaxScore: any = {};

        trueFalseScoreTypes.map((x: ScoreType) => {
            var area = x.area || '';
            var areaID = area.toLowerCase();
            if (!areasAddedTF[areaID]) {
                areasAddedTF[areaID] = true;
                availableAreasTF.push(area);
            }
        });

        likertScoreTypes.map((x: ScoreType) => {
            var area = x.area || '';
            var areaID = area.toLowerCase();
            if (!areasAddedLikert[areaID]) {
                areasAddedLikert[areaID] = true;
                availableAreasLikert.push(area);
            }
        });

        maxScoreTypes.map((x: ScoreType) => {
            var area = x.area || '';
            var areaID = area.toLowerCase();
            if (!areasAddedMaxScore[areaID]) {
                areasAddedMaxScore[areaID] = true;
                availableAreasMaxScore.push(area);
            }
        });

        availableAreasTF.sort((area1: string, area2: string) => {
            if (area1 > area2) {
                return 1;
            } else if (area1 < area2) {
                return -1;
            }
            return 0;
        });

        availableAreasLikert.sort((area1: string, area2: string) => {
            if (area1 > area2) {
                return 1;
            } else if (area1 < area2) {
                return -1;
            }
            return 0;
        });

        availableAreasMaxScore.sort((area1: string, area2: string) => {
            if (area1 > area2) {
                return 1;
            } else if (area1 < area2) {
                return -1;
            }
            return 0;
        });

        var rawScoreSelected = this.selectedRawScore();

        return (
            <>
                <div className="title-header">True False</div>

                {
                    availableAreasTF.map((x: string, areaIndex: number) => {
                        return <div key={`area-tf-${areaIndex}`}>
                            <div className="title-header title-header-small"><small>{x}</small></div>
                            {trueFalseScoreTypes.filter((s: ScoreType) => {
                                var area = s.area || '';
                                return area.toLowerCase() === x.toLowerCase();
                            }).sort(this.sortScoreType).map((rawScore: ScoreType, ind: number) => {
                                return <div key={`select-opt-${rawScore.id}`}>
                                    <div className="option" onClick={(e) => this.rawScoreChange(rawScore)} key={`rawScore-${rawScore.id}`}> {ind + 1}. {rawScore.name}</div>
                                </div>;
                            })}
                        </div>;
                    })
                }

                <div className="title-header">Likert</div>

                {
                    availableAreasLikert.map((x: string, areaIndex: number) => {
                        return <div key={`area-likert-${areaIndex}`}>
                            <div className="title-header title-header-small">
                                <small>{x}</small>
                            </div>
                            {
                                likertScoreTypes.filter((s: ScoreType) => {
                                    var area = s.area || '';
                                    return area.toLowerCase() === x.toLowerCase();
                                }).sort(this.sortScoreType).map((rawScore: ScoreType, ind: number) => {
                                    return <div key={`select-opt-${rawScore.id}`}>
                                        <div className="option" onClick={(e) => this.rawScoreChange(rawScore)} key={`rawScore-${rawScore.id}`}> {ind + 1}. {rawScore.name}</div>
                                    </div>;
                                })
                            }
                            <div className="title-header">Meta Scores</div>
                            {
                                availableAreasMaxScore.map((x: string, areaIndex: number) => {
                                    return <div key={`area-maxscore-${areaIndex}`}>
                                        <div className="title-header title-header-small"><small>{x}</small></div>
                                        {
                                            maxScoreTypes.filter((s: ScoreType) => {
                                                var area = s.area || '';
                                                return area.toLowerCase() === x.toLowerCase();
                                            }).sort(this.sortScoreType).map((rawScore: ScoreType, ind: number) => {
                                                return <div key={`select-opt-${rawScore.id}`}>
                                                    <div className="user-row" onClick={(e) => this.rawScoreChange(rawScore)} key={`rawScore-${rawScore.id}`}> {ind + 1}. {rawScore.name}</div>
                                                </div>;
                                            })
                                        }
                                    </div>;
                                })
                            }
                        </div>;
                    })
                }
            </>
        )
    }

    render() {
        const options = this.props.options.map(o => ({ id: o.id, label: o.name }));

        return (
            <PVASelect
                options={options}
                selected={this.props.selected}
                onChange={this.props.onChange}
                noSelectTitle="- Select -"
                stretch={true}
                renderOptions={this.renderOptions}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVARawScoreSelect.tsx